//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['list'],
    created() {
        console.log(this.list);
    },
    methods: {
        lookNumber(res) {
            if (res.isTrue) {
                res.isTrue = false;
            } else {
                this.$set(res, 'isTrue', true);
            };
        }
    },
    filters: {
        status(val) {
            switch (val) {
                case "WORKING":
                    return '进行中'
                    break;

                case "ENDING":
                    return '已揭晓'
                    break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/takeWine/list.vue